import * as AuthSession from 'expo-auth-session'
import AsyncStorage from '@react-native-async-storage/async-storage'
import axios from 'axios'

import {
  CLIENT_ID,
  discovery,
  OCP_APIM_SUBSCRIPTION_KEY,
  API_BASE_URL
} from '../config'

import { authService } from './../services/authService'

const createAxiosInstance = () => {
  const instance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Ocp-Apim-Subscription-Key': OCP_APIM_SUBSCRIPTION_KEY,
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': '0',
    }
  })

  // add an interceptor to modify the request configuration
  instance.interceptors.request.use(
    async (config) => {
      let accessToken = null

      // check if the persisted token's validity
      const isTokenExpired = await authService.isPersistedAuthExpired()

      // get the authorization token from AsyncStorage
      const serializedToken = await AsyncStorage.getItem('@Auth')
      const token: AuthSession.TokenResponse = serializedToken
        ? JSON.parse(serializedToken)
        : null

      accessToken = token.accessToken

      if (isTokenExpired) {
        if (token) {
          const newToken = await authService.getNewToken(
            CLIENT_ID,
            token,
            discovery
          )
          accessToken = newToken.accessToken
        }
      }

      // add the access token to the request headers
      config.headers.Authorization = `Bearer ${accessToken}`

      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  return instance
}

const client = createAxiosInstance()

export { client }
